import { render, staticRenderFns } from "./AppProvidersHeader.vue?vue&type=template&id=de3b5900&scoped=true"
import script from "./AppProvidersHeader.vue?vue&type=script&lang=js"
export * from "./AppProvidersHeader.vue?vue&type=script&lang=js"
import style0 from "./AppProvidersHeader.vue?vue&type=style&index=0&id=de3b5900&prod&scoped=true&lang=css"
import style1 from "./AppProvidersHeader.vue?vue&type=style&index=1&id=de3b5900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3b5900",
  null
  
)

export default component.exports